export class DianosisGroupStatusesLookup {
    getLookup() {
        let dianosisGroupStatuses = [];
        dianosisGroupStatuses.push({ label: 'All', value: null });
        dianosisGroupStatuses.push({ label: 'Active', value: true });
        dianosisGroupStatuses.push({ label: 'In Active', value: false });
        return dianosisGroupStatuses;
   };
}
